module.exports = __webpack_public_path__ + "img/8.ba910483.jpg";